import React, { useState } from "react";
import Layout from "../../../components/Accounts/Layout";
import { InputItem } from "../data";
import InputContainer from "../../../components/Accounts/InputContainer";
import Button from "../../../components/Button/Button";
import { Formik } from "formik";
import * as Yup from "yup";
import { businessDetailsInputs } from "./data";
import { InputAndTransactionFeeWrapper } from "../FipayTransfer/PaymentDetails";
import { UploadIcon } from "../../../../public/assets";
import TextArea from "../../../components/Accounts/TextArea";
import { useDispatch, useSelector } from "react-redux";
import { setFormValues } from "../../../store/formValues";
import { RootState } from "../../../store/rootReducer";

interface PaymentDetailsProps {
  handleNext: (step: number) => void;
  prevValues: InputItem[];
  transferType: string;
}

const BusinessDetails: React.FC<PaymentDetailsProps> = ({
  handleNext,
  prevValues,
  transferType,
}) => {
  const dispatch = useDispatch();
  const formValues = useSelector(
    (state: RootState) => state.formValues.wireTransfer
  );
  const [formikValues, setFormikValues] = useState<{
    Website: string;
    GoodsType: string;
    SupportingDoc: File | null;
    Memo: string;
  }>({
    Website: formValues?.Website || "",
    GoodsType: formValues?.GoodsType || "",
    SupportingDoc: formValues?.SupportingDoc || null,
    Memo: formValues?.Memo || "",
  });
  const handleSupportingDocChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = e.target.files![0];
    setFormikValues((prevValues) => ({ ...prevValues, SupportingDoc: file }));
  };

  return (
    <Layout>
      <Formik
        initialValues={formikValues}
        validationSchema={Yup.object({
          Website: Yup.string().required("Required"),
          GoodsType: Yup.string().required("Required"),
          SupportingDoc: Yup.string().required("Required"),
        })}
        onSubmit={(values) => {
          try {
            handleNext(2);
            const formData = {
              ...prevValues,
              ...values,
            };

            dispatch(setFormValues({ [transferType]: formData }));
          } catch (error) {
            console.error("Error submitting form:", error);
          }
        }}
      >
        {(formik) => (
          <form onSubmit={formik.handleSubmit}>
            <>
              {businessDetailsInputs.map((input, index) =>
                input.name === "Memo" ? (
                  <TextArea
                    label={input.label}
                    onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                      const { name, value } = e.target;
                      formik.handleChange({
                        target: {
                          name,
                          value,
                        },
                      });
                    }}
                    name={input.name}
                  />
                ) : (
                  <InputAndTransactionFeeWrapper key={index}>
                    <InputContainer
                      name={input.name}
                      label={input.label}
                      type={input.type}
                      placeholder={input.placeholder}
                      docName={
                        input.type === "file"
                          ? formikValues.SupportingDoc
                          : null
                      }
                      onChange={(e) => {
                        formik.handleChange(e);
                        return input.type === "file"
                          ? handleSupportingDocChange(e)
                          : () => {};
                      }}
                      width={"100%"}
                      error={
                        formik.touched[
                          input.name as keyof typeof formik.touched
                        ] &&
                        formik.errors[input.name as keyof typeof formik.errors]
                      }
                      icon={
                        input.hasIcon
                          ? "/assets/svg/upload-icon.svg"
                          : undefined
                      }
                      className={input.type === "file" ? "hidden" : ""}
                      hasBorder={input.type === "file"}
                    />
                  </InputAndTransactionFeeWrapper>
                )
              )}
            </>
            <Button
              id={""}
              type="submit"
              padding={"10px 45%"}
              title={"Next"}
              border="10px"
              green
              disabled={!formik.isValid || !formik.dirty}
            />
          </form>
        )}
      </Formik>
    </Layout>
  );
};

export default BusinessDetails;
